import { env } from '@/utils'

export const generateLocaleStaticParams = () =>
	env.LOCALE_LIST.map((locale) => ({ locale }))
